<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        BOOKING
      </button>
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title pl-2">BOOKING</span>
        </div>
        <div class="filter-body-wrapper">
          <bookings-filter :storeFilter="storeFilter"></bookings-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <bookings-list :storeFilter="storeFilter" :storePage="storePage"></bookings-list>
      </v-container>
      <create-booking></create-booking>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import BookingsFilter from '@/components/admin/bookings/BookingsFilter';
  import BookingsList from '@/components/admin/bookings/BookingsList';
  import CreateBooking from '@/components/admin/bookings/CreateBooking';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        bookingsEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      BookingsFilter, BookingsList, CreateBooking, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Bookings.vue